import { render, staticRenderFns } from "./add-bank-card.vue?vue&type=template&id=3c42bc76&scoped=true&"
import script from "./add-bank-card.vue?vue&type=script&lang=js&"
export * from "./add-bank-card.vue?vue&type=script&lang=js&"
import style0 from "./add-bank-card.vue?vue&type=style&index=0&id=3c42bc76&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c42bc76",
  null
  
)

export default component.exports